import { type NewContainer } from '@sr/types';
import { isCustomContainerType } from '@sr/utils';

export const validatedContainerFields = [
  'material',
  'materialOther',
  'containerType',
  'otherLoadCarrierType',
  'amount',
  'date',
] as const satisfies (keyof NewContainer)[];

export type ValidatedContainerField = (typeof validatedContainerFields)[number];

export const createEmptyContainer = (): NewContainer => ({ id: crypto.randomUUID() });

export const isOtherMaterial = (material?: string) => material === 'other';

const inputFields = [...validatedContainerFields, 'palletCollarAmount'] as const;

export const isEmptyContainer = (container: NewContainer) =>
  inputFields.every((field) => !container[field]);

export const hasFilledContainers = (containers?: NewContainer[]) =>
  !!containers?.some((container) => !isEmptyContainer(container));

export const getMissingContainerFields = (container: NewContainer): ValidatedContainerField[] => {
  const requiredFields: ValidatedContainerField[] = ['material', 'containerType'];

  if (isOtherMaterial(container.material)) {
    requiredFields.push('materialOther');
  }

  if (isCustomContainerType(container.containerType)) {
    requiredFields.push('otherLoadCarrierType');
  } else {
    requiredFields.push('amount', 'date');
  }

  return requiredFields.filter((field) => !container[field]);
};
